import { type IPromotionPage } from '@entities/promotion';
import { SmartLink } from '@shared/lib/routing';
import { PromoCardDesktop } from './PromoCardDesktop';
import { PromoCardMobile } from './PromoCardMobile';

interface IPromotionCard {
  mainDomain: string;
  item: IPromotionPage;
  categoryName?: string;
}

export function PromotionCard({
  item,
  mainDomain,
  categoryName,
}: IPromotionCard) {
  const { link, has_static_page, text_id, images } = item;
  let stockLink = '';
  if (has_static_page) {
    stockLink = `/akcii/${encodeURIComponent(text_id)}`;
  } else if (link) {
    stockLink = link;
  }

  const mobileImage = images.find(
    ({ section }) => section === 'stock_page_mobile',
  )?.filename;
  const desktopImage = images.find(
    ({ section }) => section === 'stock_page',
  )?.filename;

  if (!mobileImage && !desktopImage) {
    return null;
  }

  const params = {
    item,
    mainDomain,
    categoryName,
  };

  if (stockLink) {
    return (
      <>
        {desktopImage && (
          <SmartLink className="m-0 hidden h-full lg:block" href={stockLink}>
            <PromoCardDesktop image={desktopImage} {...params} />
          </SmartLink>
        )}
        {mobileImage && (
          <SmartLink className="m-0 block h-full lg:hidden" href={stockLink}>
            <PromoCardMobile image={mobileImage} {...params} />
          </SmartLink>
        )}
      </>
    );
  }
  return (
    <>
      {desktopImage && (
        <div className="m-0 hidden h-full lg:block">
          <PromoCardDesktop image={desktopImage} {...params} />
        </div>
      )}
      {mobileImage && (
        <div className="m-0 block h-full lg:hidden">
          <PromoCardMobile image={mobileImage} {...params} />
        </div>
      )}
    </>
  );
}
